/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PurgeQueueResponse
 */
export interface PurgeQueueResponse {
  /**
   *
   * @type {number}
   * @memberof PurgeQueueResponse
   */
  purgedCount: number;
}

/**
 * Check if a given object implements the PurgeQueueResponse interface.
 */
export function instanceOfPurgeQueueResponse(
  value: object,
): value is PurgeQueueResponse {
  if (!("purgedCount" in value) || value["purgedCount"] === undefined)
    return false;
  return true;
}

export function PurgeQueueResponseFromJSON(json: any): PurgeQueueResponse {
  return PurgeQueueResponseFromJSONTyped(json, false);
}

export function PurgeQueueResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PurgeQueueResponse {
  if (json == null) {
    return json;
  }
  return {
    purgedCount: json["purgedCount"],
  };
}

export function PurgeQueueResponseToJSON(json: any): PurgeQueueResponse {
  return PurgeQueueResponseToJSONTyped(json, false);
}

export function PurgeQueueResponseToJSONTyped(
  value?: PurgeQueueResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    purgedCount: value["purgedCount"],
  };
}
